import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['editModal', 'addUserModal']
  static values = {
    realEstateAdminId: String,
    rotationId: String,
    rotationResource: { type: String, default: 'lead_assignment_rotations' },
  }

  // Read per request: a morph refresh resets the element's attributes, so a token
  // cached in a Stimulus value would be wiped.
  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
  }

  toggleUserStatus(event) {
    event.preventDefault()

    const userId = event.target.dataset.userId
    const isActive = event.target.checked

    fetch(
      `/real_estate_admin/${this.realEstateAdminIdValue}/${this.rotationResourceValue}/${this.rotationIdValue}/toggle_user_status`,
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken,
          Accept: 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          active: isActive,
        }),
      }
    )
      .then((response) => {
        if (!response.ok) {
          event.target.checked = !isActive
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then((data) => {
        if (data.status === 'success') {
          console.log(data.message)
          window.location.reload()
        } else {
          throw new Error(data.message)
        }
      })
      .catch((error) => {
        console.error('Error toggling user status:', error)
        alert('Erro ao alterar status do usuário')
        event.target.checked = !isActive
      })
  }

  changeRepeat(event) {
    const { url, method } = event.currentTarget.dataset
    const buttons = this.element.querySelectorAll('[data-action~="rotation-management#changeRepeat"]')
    if ([...buttons].some((button) => button.disabled)) return
    buttons.forEach((button) => (button.disabled = true))

    fetch(url, {
      method,
      headers: { 'X-CSRF-Token': this.csrfToken, Accept: 'application/json' },
    })
      .then((response) => response.json().catch(() => ({})))
      .then((data) => {
        if (data.status !== 'success') throw new Error(data.message)
        window.location.reload()
      })
      .catch((error) => {
        window.showNotification(error.message || 'Erro ao alterar as vezes do usuário na roleta. A página será recarregada.', 'error')
        setTimeout(() => window.location.reload(), 2000)
      })
  }

  toggleWhatsappNotification(event) {
    event.preventDefault()

    const userId = event.target.dataset.userId
    const isEnabled = event.target.checked

    fetch(
      `/real_estate_admin/${this.realEstateAdminIdValue}/${this.rotationResourceValue}/${this.rotationIdValue}/toggle_user_whatsapp_notification`,
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken,
          Accept: 'application/json',
        },
        body: JSON.stringify({ user_id: userId }),
      }
    )
      .then((response) => {
        if (!response.ok) {
          event.target.checked = !isEnabled
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then((data) => {
        if (data.status !== 'success') {
          event.target.checked = !isEnabled
          throw new Error(data.message)
        }
        console.log(data.message)
      })
      .catch((error) => {
        console.error('Error toggling WhatsApp notification:', error)
        alert('Erro ao alterar notificação por WhatsApp do usuário')
        event.target.checked = !isEnabled
      })
  }

  toggleSetting(event) {
    event.preventDefault()

    const url = event.params.url
    const isEnabled = event.target.checked

    fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken,
        Accept: 'application/json',
      },
      body: JSON.stringify({ enabled: isEnabled }),
    })
      .then((response) => {
        if (!response.ok) {
          event.target.checked = !isEnabled
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then((data) => {
        if (data.status === 'success') {
          window.location.reload()
        } else {
          throw new Error(data.message)
        }
      })
      .catch((error) => {
        console.error('Error toggling setting:', error)
        alert('Erro ao alterar configuração')
        event.target.checked = !isEnabled
      })
  }

  changeSetting(event) {
    const url = event.params.url
    const value = event.target.value

    fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken,
        Accept: 'application/json',
      },
      body: JSON.stringify({ value: value }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok')
        return response.json()
      })
      .then((data) => {
        if (data.status === 'success') {
          window.location.reload()
        } else {
          throw new Error(data.message)
        }
      })
      .catch((error) => {
        console.error('Error changing setting:', error)
        alert('Erro ao alterar configuração')
      })
  }
}
